import { IS_AUTO_TEST_HIDE, IS_MAIL_APP_IOS, IS_WEBVIEW_FROM_UA } from 'reactApp/appHelpers/configHelpers';
import { autoUploadOnboarding } from 'reactApp/appHelpers/featuresHelpers/features/autoUploadPromo';
import { productsController } from 'reactApp/modules/products/products.controller';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown, removePromo } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { SettingsSelectors } from 'reactApp/modules/settings/settings.selectors';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { UserStorageActions } from 'reactApp/modules/user/userStorage';
import { openAutoUploadOnboadingDialog } from 'reactApp/sections/QuotaLanding/AutoUploadOnboardingDialog/AutoUploadOnboardingDialog.helpers';
import { store as reduxStore } from 'reactApp/store';
import { put } from 'redux-saga/effects';
import { select } from 'typed-redux-saga';

const PROMO_ID = 'autoupload-onboarding-promo';
const PROMO_CLOSED = `${PROMO_ID}-closed`;
const PERIOD_IN_DAYS = 5;

// НЕ ИСПОЛЬЗОВАТЬ: в большинстве случаев это приведет к багам
// promoShown должен отправляться в onShow, а removePromo – в onClose
// (и в onClick иногда)
function markPromoShown() {
    reduxStore.dispatch(promoShown(EPromoType.autoUploadOnboarding));
    storeHelper.markAsShown(PROMO_ID);
    reduxStore.dispatch(removePromo(EPromoType.autoUploadOnboarding));
}

export function* initAutoUploadOnboardingPromo() {
    const storage = yield* select(getCurrentStorage);
    const { isQuotaCleaner } = getStorage(storage);
    const isPaidUser = yield* select(UserSelectors.isPaidUser);
    const isCorpUser = yield* select(UserSelectors.isCorpUser);
    const promoClosed = yield put(UserStorageActions.get(PROMO_CLOSED)) || false;
    const { action = null } = yield* select(SettingsSelectors.getQueryParams) || {};

    const periodPassed = storeHelper.getValue(PROMO_ID) && storeHelper.isPassed(PROMO_ID, { daysCount: PERIOD_IN_DAYS });

    // Форс-включение промки для отдельных автотестов.
    const force = yield put(UserStorageActions.get(`force_${PROMO_ID}`)) || false;

    if (periodPassed) {
        storeHelper.clearStore(PROMO_ID);
    }

    if (
        action ||
        !autoUploadOnboarding ||
        (IS_AUTO_TEST_HIDE && !force) ||
        IS_MAIL_APP_IOS ||
        IS_WEBVIEW_FROM_UA ||
        isPaidUser ||
        isCorpUser ||
        !isQuotaCleaner ||
        promoClosed ||
        storeHelper.getValue(PROMO_ID)
    ) {
        return;
    }

    yield productsController.loadProducts();

    yield put(
        addPromoToShowQueue({
            type: EPromoType.autoUploadOnboarding,
            promoId: PROMO_ID,
            onClick: () => {
                markPromoShown();
            },
            onShow: () => {
                markPromoShown();
            },
            onClose: () => {
                markPromoShown();
                reduxStore.dispatch(UserStorageActions.set(PROMO_CLOSED, true));
            },
        })
    );
}

export function* showAutoUploadOnboardingPromo() {
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.autoUploadOnboarding));

    if (promo) {
        const { onShow, onClick, onClose } = promo;

        yield openAutoUploadOnboadingDialog({
            onClose,
            onShow,
            onClick,
        });
    }
}
